import { useContext, useMemo } from 'react'
import { JobsContext } from '../context/jobs'

export function useJobs(alias) {
  const { start, cancel, getJob, jobs, remove } = useContext(JobsContext)

  let jobsArr = useMemo(() => {
    let arr = []

    for (const [key, value] of Object.entries(jobs)) {
      arr.push({
        [key]: value,
      })
    }

    return arr
  }, [jobs])

  return {
    start,
    cancel,
    jobs: jobsArr,
    remove,
    ...(alias ? getJob(alias) : {}),
  }
}
